<script>
import Rms from './Rms/Rms.vue'
import Power from './Power/Power.vue'
import PFactor from './PFactor/PFactor.vue'
import EQuantity from './EQuantity/EQuantity.vue'
import Thd from './Thd/Thd.vue'
import ThdChart from './ThdChart/ThdChart.vue'
import Imbalance from './Imbalance/Imbalance.vue'
import ThdTable from './ThdTable/ThdTable.vue'
import VectorGraph from './VectorGraph/VectorGraph.vue'
import thdChartRange from './ThdChart/ThdChartRange.vue'
import ThdTableRange from './ThdTable/ThdTableRange.vue'
export default {
  name: 'Stable',
  components: {
    Rms,
    Power,
    PFactor,
    EQuantity,
    Thd,
    ThdChart,
    ThdTable,
    Imbalance,
    VectorGraph,
    thdChartRange,
    ThdTableRange
  },
  data () {
    return {
      page: 1,
      stableData: {},
      interval: null,
      lastTs: 0,
      commandInterval: null
    }
  },
  computed: {
    stablePage () {
      return this.$store.state.reqMode === 'udp' ? 40 : 30
    },
    collection () {
      return this.$store.state.highSpdMode ? 'meter_fast_stable_data' : 'meter_stable_data'
    }
  },
  watch: {
    page () {
      this.setInterval()
    },
    '$store.state.highSpdMode' () {
      this.setInterval()
    }
  },
  mounted () {
    this.pollCommand()
    this.updateData()
    this.setInterval()
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.pollStop()

    // 关闭快速模式
    if (this.commandInterval) {
      clearInterval(this.commandInterval)
      this.commandInterval = null
    }
    this.$store.commit('updateSpeedMode', '普通模式')
  },
  methods: {
    setInterval () {
      if (this.page !== 4) {
        if (!this.interval) {
          this.interval = setInterval(() => {
            var sn = this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn')
            if (!sn) return
            this.$api.getTs({
              collection: this.collection,
              sn
            }).then((res) => {
              console.log('AAA')
              console.log(res)
              if (res.data.code !== 0) {
                this.$message.error(res.data.msg)
                return
              }
              if (this.lastTs !== res.data.data.ts) {
                this.lastTs = res.data.data.ts
                this.updateData()
              }
            })
          }, 1000)
        }
        this.pollCommand()
      } else if (this.page === 3) {
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }
        this.pollStop()
      }
    },
    currentPage (page) {
      this.page = page
    },
    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand()
        if (!this.commandInterval) {
          this.commandInterval = setInterval(() => {
            this.sendCommand()
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.commandInterval) {
        clearInterval(this.commandInterval)
        this.commandInterval = null
      }
    },
    sendCommand () {
      this.$api.command({
        sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        lists: [[1, 6, 0]]
      }).then(res => {
        console.log('BBB')
        console.log(res)
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    async updateData () {
      const params = {
        'collection': this.collection,
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'fields': ['ua_rms', 'ub_rms', 'uc_rms', 'rms_refer', 'freq_refer', 'uab_rms', 'ubc_rms', 'uca_rms', 'i_laek_rms', 'ia_rms', 'ib_rms', 'ic_rms', 'in_rms', 'ua_rms_fund', 'ub_rms_fund', 'uc_rms_fund', 'uab_rms_fund', 'ubc_rms_fund', 'uca_rms_fund', 'ia_rms_fund', 'ib_rms_fund', 'ic_rms_fund', 'in_rms_fund', 'p_pha', 'p_phb', 'p_phc', 'p_total', 'q_pha', 'q_phb', 'q_phc', 'q_total', 's_pha', 's_phb', 's_phc', 's_total', 'qf_pha', 'qf_phb', 'qf_phc', 'qf_total', 'qh_pha', 'qh_phb', 'qh_phc', 'qh_total', 'pf_pha', 'pf_phb', 'pf_phc', 'pf_total', 'dpf_pha', 'dpf_phb', 'dpf_phc', 'dpf_total', 'ea_kwh', 'eb_kwh', 'ec_kwh', 'et_kwh', 'ea_kvarh', 'eb_kvarh', 'ec_kvarh', 'et_kvarh', 'ea_kvah', 'eb_kvah', 'ec_kvah', 'et_kvah', 'start_time', 'thd_ua_f', 'thd_ub_f', 'thd_uc_f', 'thd_uab_f', 'thd_ubc_f', 'thd_uca_f', 'thd_ia_f', 'thd_ib_f', 'thd_ic_f', 'thd_in_f', 'thd_ua_r', 'thd_ub_r', 'thd_uc_r', 'thd_uab_r', 'thd_ubc_r', 'thd_uca_r', 'thd_ia_r', 'thd_ib_r', 'thd_ic_r', 'thd_in_r', 'fft_ua', 'fft_ub', 'fft_uc', 'fft_uab', 'fft_ubc', 'fft_uca', 'fft_ia', 'fft_ib', 'fft_ic', 'fft_in', 'uph_pos', 'uph_neg', 'uph_zero', 'unbal_uph', 'ull_pos', 'ull_neg', 'ull_zero', 'unbal_ull', 'i_pos', 'i_neg', 'i_zero', 'unbal_i', 'rms_refer', 'delt_ua', 'delt_ub', 'delt_uc', 'freq_a', 'freq_b', 'freq_c', 'freq_refer', 'delt_freqa', 'delt_freqb', 'delt_freqc', 'theta_ua', 'theta_ub', 'theta_uc', 'theta_ia', 'theta_ib', 'theta_ic']
      }
      const {data: res} = await this.$api.queryLastData(params)
      console.log('CCC')
      console.log(res)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      this.stableData = res.data
      // console.log(data)
    }
  }
}
</script>

<template>
  <div class="page">
    <div class="dataBorder">
      <Power v-if="page===1" :stableData="stableData"></Power>
      <PFactor v-if="page===1" :stableData="stableData"></PFactor>
      <Rms v-if="page===1" :stableData="stableData"></Rms>
      <Imbalance v-if="page===1" :stableData="stableData"></Imbalance>
      <Thd v-if="page===2" :stableData="stableData"></Thd>
      <ThdChart v-if="page===2" :stableData="stableData"></ThdChart>
      <ThdTable v-if="page===2" :stableData="stableData"></ThdTable>
      <EQuantity v-if="page===2" :stableData="stableData"></EQuantity>
      <VectorGraph v-if="page===3" :stableData="stableData"></VectorGraph>
      <thdChartRange v-if="page===4" :stableData="stableData"></thdChartRange>
      <ThdTableRange v-if="page===4"></ThdTableRange>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="stablePage"
      @current-change="currentPage">
    </el-pagination>
  </div>
</template>

<style scoped>
.page {
  width: 100%;
  height: 100%;
}

.dataBorder {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(90vh - 70px);
//overflow: auto; display: flex; flex-wrap: wrap;
  justify-content: space-between;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Stable/Stable.vue